const defaultOptions = {
  bottom: true,
  color: '',
  message: '',
  right: true,
  timeout: 10000,
  visible: false
}

const snackbar = {
  namespaced: true,
  state: {
    bottom: true,
    color: '',
    message: '',
    right: true,
    timeout: 10000,
    visible: false
  },
  getters: {
    isVisible: function (state, getters, rootState, rootGetters) {
      return state.visible
    }
  },
  mutations: {
    setVisible: function (state, payload = defaultOptions) {
      const options = Object.assign({}, defaultOptions, payload)
      state.visible = options.visible
      state.bottom = options.bottom
      state.message = options.message
      state.right = options.right
      state.color = options.color
      state.timeout = options.timeout
    }
  },
  actions: {
    setSnackBar: async function (context, payload = defaultOptions) {
      context.commit('setVisible', payload)
    }
  }
}

export default snackbar
